import { Result } from "ysd-pp";

function Page500() {
    return <Result title={500} subTitle={"抱歉, 服务器报错！"} />;
}

export default Page500;
